import toastr from "toastr";
window.toastr = toastr;
if (
    typeof messages_notify !== "undefined" &&
    typeof messages_notify.message !== "undefined" &&
    messages_notify.message.length
) {
    toastr[messages_notify.type](messages_notify.message, { timeOut: 5000 });
}
